import React from "react";

import { ToastContext } from "../Components/ToastProvider";

import Toast from "../Components/Toast";

function ToastShelf() {
  const { toasts } = React.useContext(ToastContext);

  return (
    <ol className="toast-main-wrapper" role="region" aria-live="polite">
      {toasts?.map((toast) => (
        <li key={toast.id} className="toast-wrapper">
          <Toast
            id={toast.id}
            variant={toast.variant}
            message={toast.message}
          />
        </li>
      ))}
    </ol>
  );
}

export default ToastShelf;
